import { render, staticRenderFns } from "./RefundForm.vue?vue&type=template&id=20343b7b"
import script from "./RefundForm.vue?vue&type=script&lang=js"
export * from "./RefundForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports